import { SYSTEMS_API_NAMED_KEYS } from '@/modules/Auth/constants';
import { apiService, customApiService } from '@/services/APIService';

export default {
  getPublicUser(id, params) {
    return apiService.get(`/public/users/${id}`, params);
  },

  // получение пользователей с их ролями
  // в query expand=roles
  getPublicUsers(params) {
    return apiService.get('/public/users', params);
  },

  getPublicUsersCached(params) {
    return apiService.getCached('/public/users', params);
  },

  // получение информации пользователя
  getUser(params) {
    return apiService.get('/user', params);
  },

  getRatings(params) {
    return apiService.get('/ratings/', params);
  },

  getUserRating(id, params) {
    return apiService.get('/user/ratings', params);
  },

  updateUser(params) {
    return apiService.put('/user', params);
  },

  updateMember(params) {
    return apiService.put('/user/member', params);
  },

  updateTrainer(params) {
    return apiService.put('/user/trainer', params);
  },

  updateProfile(params) {
    return apiService.put('/user/profile?expand=avatar', params);
  },

  getOrganizators(params) {
    return apiService.get('/public/organizers', params);
  },

  getOrganizatorsCached(params) {
    return apiService.getCached('/public/organizers', params);
  },

  showPublicOrganizer(id, params) {
    return apiService.get(`/public/organizers/${id}`, params);
  },

  showPublicOrganizerCached(id, params) {
    return apiService.getCached(`/public/organizers/${id}`, params);
  },

  showOrganizer(id, params) {
    return apiService.get(`/organizers/${id}`, params);
  },

  updateOrganization(id, params) {
    return apiService.put(`/organizers/${id}`, params);
  },

  updateOrganizationAvatar(id, params) {
    return apiService.put(`/organizers/${id}/avatar`, params);
  },

  showMunicipality(id, params) {
    return apiService.get(`/municipalities/${id}`, params);
  },

  sendVerifyEmail() {
    return apiService.post('/verify/email');
  },

  verifyEmail(params) {
    return apiService.put('/verify/email', params);
  },

  getUserEventInfo(id, params) {
    return apiService.get(`/user/event-info/${id}`, params);
  },

  getUserEventRequests(params) {
    return apiService.get('/event-user-requests', params);
  },

  getTimezones() {
    return apiService.get('/lists/timezones');
  },

  setTimezone(value) {
    return apiService.post('/user/set-timezone', value);
  },
  confirmEmailChange(params) {
    return apiService.put('/user/email', params);
  },
  deleteEmail(params) {
    return apiService.delete('/user/email', params);
  },
  confirmEmail(params) {
    return apiService.put('/user/email-confirm', params);
  },
  changeEmailRemove(id) {
    return apiService.delete(`/user/change-email/${id}`);
  },
  emailSendCode(params) {
    return apiService.post('/user/email/send-code', params);
  },
  emailCodeConfirm(params) {
    return apiService.post('/user/email/confirm', params);
  },
  massStore(params) {
    return apiService.post('/user-event-info/mass-store', params);
  },

  // USER DUPLICATE
  duplicateInit(params) {
    return apiService.post('/user-duplicates', params);
  },

  // USER REMOVE/DELETE ACCOUNT
  deleteAccount(params) {
    return apiService.post('/user/destroy-initiate', params);
  },
  deleteAccountCancel(params) {
    return apiService.post('/user/destroy-cancel', params);
  },

  // USER event info requests

  getUserEventInfoRequests(params) {
    return apiService.get('/user-event-info-requests', params);
  },

  /* TRASHFIX:
    Временный запрос на определение участовал
    ли пользователь в указанном мероприятии
  */
  getParticipateUser(id) {
    return apiService.get(`/event-${id}`);
  },

  checkVchtUsers(params) {
    return customApiService(SYSTEMS_API_NAMED_KEYS.VCHT).get('/public/users', params);
  },

  checkEventsUsers(params) {
    return customApiService(SYSTEMS_API_NAMED_KEYS.EVENTS).get('/public/users', params);
  },

  transferUser(params) {
    return apiService.post('/auth/transfer-user/send', params);
  },

  confirmTransfer(params) {
    return apiService.post('/auth/transfer-user/link-confirm', params);
  },

  switchActiveSystem(params) {
    return apiService.put('/user/active-system', params);
  },

  deleteProfile() {
    return apiService.delete('/user/destroy');
  },

  preRegisterUser(payload) {
    return apiService.post('/preregistration-member', payload);
  },

  updateUnderUser(payload) {
    return apiService.put('/user/underuser-profile', payload);
  },

  attachTrainerRole(payload) {
    return apiService.post('/user/extender/attach-trainer', payload);
  },

  attachExpertRole(payload) {
    return apiService.post('/user/extender/attach-expert', payload);
  },

  attachEventManagerRole(payload) {
    return apiService.post('/user/extender/attach-event-manager', payload);
  },

  authExtenderUser(payload) {
    return apiService.post('/user/extender/auth', payload);
  },

  makeTrainerRole(payload = {}) {
    return apiService.post('/user/extender/make-trainer', payload);
  },

  // User Attributes
  getUserAttributes(params) {
    return apiService.get('/user-attributes', params);
  },
  getUserAttributesCached(params) {
    return apiService.getCached('/user-attributes', params);
  },
  getUserAttributesAuto(params) {
    return apiService.get('/user-attribute-autocompletes', params);
  },

  saveUserAttributes(payload) {
    return apiService.post('/user-attributes', payload);
  },

  getUserEventAdditionalInfo(params) {
    return apiService.get(`/user-event-info`, params);
  },

  updateUserAttributesByOrganizer(payload) {
    return apiService.post('/user-attributes/by-org', payload);
  },

  getSimpleAuthUriTg(params) {
    return apiService.get('/auth/simple-auth/telegram/uri', params);
  },
  simpleAuthByTg(payload) {
    return apiService.post('/auth/simple-auth/telegram/auth', payload);
  },

  getSimpleAuthUriVk(params) {
    return apiService.get('/auth/simple-auth/vk/uri', params);
  },
  simpleAuthByVk(payload) {
    return apiService.post('/auth/simple-auth/vk/auth', payload);
  },

  getSimpleAuthUriYandex(params) {
    return apiService.get('/auth/simple-auth/yandex/uri', params);
  },
  simpleAuthByYandex(payload) {
    return apiService.post('/auth/simple-auth/yandex/auth', payload);
  },

  simpleAuthByMaxSendCode(payload) {
    return apiService.post('/auth/simple-auth/max/phone', payload);
  },
  simpleAuthByMax(payload) {
    return apiService.post('/auth/simple-auth/max/auth', payload);
  },
  simpleAuthByMaxIsMet(payload) {
    return apiService.post('/auth/simple-auth/max/is-met', payload);
  },

  certificateLinkCheck({ certificate_number }) {
    return apiService.post('/certificate-link/check', { certificate_number }).then((response) => {
      // Check is specified by HTTP status; also accept a response without the usual API envelope.
      if (response.status === 200 && !response.data?.result_code) {
        return { ...response, data: { result_code: 'FLSCS', data: response.data?.data ?? response.data } };
      }
      return response;
    });
  },
  certificateLinkSendCode({ certificate_number, email }) {
    return apiService.post('/certificate-link/email/send-code', { certificate_number, email });
  },
  certificateLinkConfirmEmail({ certificate_number, code }) {
    return apiService.post('/certificate-link/email/confirm', { certificate_number, code });
  },
  certificateLinkConfirmCredentials({ certificate_number, username, password }) {
    return apiService.post('/certificate-link/credentials/confirm', { certificate_number, username, password });
  },
  certificateLinkDelete() {
    return apiService.delete('/certificate-link');
  },

  unlinkMax(payload) {
    return apiService.post('/user/forget-max', payload);
  },
  unlinkVk(payload) {
    return apiService.post('/user/forget-vk', payload);
  },
  unlinkYandex(payload) {
    return apiService.post('/user/forget-yandex', payload);
  },
  unlinkApple(payload) {
    return apiService.post('/user/forget-apple', payload);
  },
};
